import { ExpandMore } from "@mui/icons-material"
import { useEffect, useRef, useState } from "react";
import { GetAllAlmacenesList } from "../../../hooks/getListAlmacen";
import { Autocomplete, Box, Button, FormControl, FormLabel, Grid, TextField } from "@mui/material";
import { useLoading } from "../../../components/Loading/useLoading";
import { GetTurnos } from "../../../hooks/turnos";
import moment from "moment";
import { DownloadExcelTurnos } from "../../../hooks/reportesTurno";

export const TurnosFiltro = ({ get_data, canDownXlsx }) => {

  const formOrden = useRef(null);
  const { setAppLoading } = useLoading();
  const [isOpen, setIsOpen] = useState(true);
  const { getTurnosMutation } = GetTurnos();
  const { getAllAlmacenesListMutation } = GetAllAlmacenesList();
  const { getDownloadExcelTurnos } = DownloadExcelTurnos();
  const [turnos, setTurnos] = useState([]);
  const [turnoSelect, setTurnoSelect] = useState(null);
  const [almacenes, setAlmacenes] = useState([]);
  const [almaSelect, setAlmaSelect] = useState(null);
  const [inicio, setInicio] = useState(moment().format('YYYY-MM-DD'));
  const [final, setFinal] = useState(moment().format('YYYY-MM-DD'));

  useEffect(() => {
    get_almacenes();
    get_turnos();
  }, []);

  const toggleCollapser = () => {
    setIsOpen(!isOpen);
  };
  const get_almacenes = () => {
    setAppLoading(true);
    getAllAlmacenesListMutation(
      {},
      {
        onSuccess: (data) => {
          setAlmacenes(data);
          setAppLoading(false);
        },
        onError: (error) => {
          console.log(error);
          setAppLoading(false);
        },
      }
    );
  };
  const get_turnos = () => {
    getTurnosMutation({}, {
      onSuccess: (data) => {
        setTurnos(data)
      },
      onError: (error) => {
        console.log(error)
      }
    })
  }
  const handleKeyUp = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };
  const sumbmitFiltro = () => {
    get_data(almaSelect?.id, turnoSelect?.turn_id, inicio, final);
  }

  const downloadMainExcel = () => {
    setAppLoading(true)
    getDownloadExcelTurnos({ almacen: almaSelect?.id, turno: turnoSelect?.turn_id, inicio, final },
      {
        onSuccess: (data) => {
          const blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `galus_reporte_turnos_${almaSelect?.label}_${turnoSelect ? turnoSelect?.turn_nombre : ''}_${inicio ? inicio : ''}_${final ? final : ''}.xlsx`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        },
        onError: (error) => {
          console.error('Error al descargar el Excel', error);
        },
        onSettled: () => {
          setAppLoading(false);
        }
      }
    )
  }

  const downloadMainExcelByUser = () => {
    setAppLoading(true)
    getDownloadExcelTurnos({ almacen: almaSelect?.id, turno: turnoSelect?.turn_id, inicio, final, usuarios: true },
      {
        onSuccess: (data) => {
          const blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `galus_reporte_turnos_usuarios_${almaSelect?.label}_${turnoSelect ? turnoSelect?.turn_nombre : ''}_${inicio ? inicio : ''}_${final ? final : ''}.xlsx`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        },
        onError: (error) => {
          console.error('Error al descargar el Excel', error);
        },
        onSettled: () => {
          setAppLoading(false);
        }
      }
    )
  }


  return (
    <div className="collapser">
      <div className="collapser-label" onClick={toggleCollapser}>
        <span>Filtros de búsqueda</span>
        <span className="icon">
          <ExpandMore className={isOpen ? 'open' : ''} />
        </span>
      </div>
      <div className={`collapser-content ${isOpen ? 'open' : ''}`}>
        <form ref={formOrden} id="form_ord" style={{ width: '100%' }}>
          <Grid container spacing={0} sx={{ width: '100%' }}>
            <Grid item xs={12} sm={6} md={6} lg={3} xl={3} sx={{ p: '0px 5px', mt: 2 }} className="center_item">
              <FormControl variant="outlined" sx={{ width: '100%' }}>
                <FormLabel id="almacenes">
                  Almacen(es)
                </FormLabel>
                <Autocomplete
                  fullWidth
                  id="alma_id"
                  name="alma_id"
                  getOptionLabel={(opcion) => opcion?.label}
                  filterSelectedOptions
                  options={almacenes}
                  onKeyDown={handleKeyUp}
                  value={almaSelect}
                  onChange={(e, newValue) => {
                    setAlmaSelect(newValue)
                  }}
                  renderOption={(props, option) => (
                    <Box {...props} key={option?.id}>{option.label}</Box>
                  )}
                  renderInput={(params) =>
                    <TextField {...params} size="small" fullWidth />
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={3} xl={3} sx={{ p: '0px 5px', mt: 2 }} className="center_item">
              <FormControl variant="outlined" sx={{ width: '100%' }}>
                <FormLabel id="turno">
                  Turno
                </FormLabel>
                <Autocomplete
                  fullWidth
                  id="turn_id"
                  name="turn_id"
                  getOptionLabel={(opcion) => `${opcion?.turn_nombre} ${opcion?.turn_horainicio}-${opcion?.turn_horafin}`}
                  filterSelectedOptions
                  options={turnos}
                  onKeyDown={handleKeyUp}
                  value={turnoSelect}
                  onChange={(e, newValue) => {
                    setTurnoSelect(newValue)
                  }}
                  renderOption={(props, option) => (
                    <Box {...props} key={option?.turn_id}>{option?.turn_nombre} {option?.turn_horainicio}-{option?.turn_horafin}</Box>
                  )}
                  renderInput={(params) =>
                    <TextField {...params} size="small" fullWidth />
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={3} xl={3} sx={{ p: '0px 5px', mt: 2 }} className="center_item">
              <FormControl variant="outlined" fullWidth>
                <FormLabel id="start_date_label">
                  Fecha inicial
                </FormLabel>
                <TextField
                  id='filtro_start'
                  type="date"
                  fullWidth
                  size="small"
                  value={inicio}
                  name="filtro_start"
                  hiddenLabel
                  placeholder=""
                  onChange={(e) => setInicio(e.target.value)}
                  className="input-date"
                />
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={3} xl={3} sx={{ p: '0px 5px', mt: 2 }} className="center_item">
              <FormControl variant="outlined" sx={{ width: '100%' }}>
                <FormLabel id="end_date_label">
                  Fecha final
                </FormLabel>
                <TextField
                  type="date"
                  size="small"
                  id="end_date"
                  fullWidth
                  value={final}
                  onChange={
                    (e) => setFinal(e.target.value)
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sx={{ p: '0px 5px', mt: 2, display: 'inline-flex', justifyContent: 'flex-end', gap: 4 }} className="center_item">
              {
                canDownXlsx &&
                <>
                  <Button
                    variant="outlined"
                    className="btn_system"
                    sx={{ maxWidth: '250px' }}
                    disabled={!canDownXlsx}
                    onClick={downloadMainExcel}
                  >
                    Reporte General.xlsx
                  </Button>
                  <Button
                    variant="outlined"
                    className="btn_system"
                    sx={{ maxWidth: '250px' }}
                    disabled={!canDownXlsx}
                    onClick={downloadMainExcelByUser}
                  >
                    Reporte Usuarios.xlsx
                  </Button>
                </>
              }
              <Button
                variant="contained"
                className="btn_system"
                sx={{ maxWidth: '200px' }}
                onClick={sumbmitFiltro}
              >
                Buscar
              </Button>
            </Grid>
          </Grid>
        </form>
      </div>
    </div>
  )
}